/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useState, useMemo } from "react";
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  authAction,
  profileAction,
  shopAction,
  searchAction,
  brandAction,
} from "@redux/modules";

//components
import Modal from '@components/Modal';
import NavigationMenu from './NavigationMenu';  

// hooks
import useRoleAccess from '@hooks/useRoleAccess';

// utils
import { getLogoUrl, handleLogoError } from '@utils/logoHelper';
import { clearStorageRetainCookies } from '@utils/storageHelper';
import { isProgramCounterSegment } from '@utils/roleSegment.util';

// config
import { isCharityScoreEnabled } from '@config/app.config';

// services
import { API } from "@services/http.service";

//style
import "./Header.scss";

// jQuery
import $ from "jquery";

// react-icons
import {
  FaBell,
  FaShoppingCart,
  FaUser,
  FaSearch,
  FaGift,
  FaTimes,
  FaHeart,
  FaCoins,
  FaShoppingBag,
  FaStar,
  FaGamepad,
  FaEnvelope,
  FaChartBar,
  FaUserCog,
  FaReceipt,
  FaFileAlt,
  FaLightbulb,
  FaCogs,
  FaChartPie,
  FaListAlt,
  FaImages,
  FaMapMarkerAlt,
  FaSignOutAlt,
  FaRegCalendarAlt,
  FaMedal,
  FaUsers,
  FaStore,
} from 'react-icons/fa';

import Badge from "@assets/images/badge.png";

// Program bitiş takvimi yalnızca Bayi / İşletme / Usta / bayi sorumlusu segmentine
// gösterilir (bkz. @utils/roleSegment.util); veri
// modül seviyesinde önbelleğe alınır ki her sayfa geçişinde yeniden çekilmesin.
let cachedProgramEnd;
// "Kalan gün" değeri artık backend'den (strip endpoint) gelir; admin bütçe
// dashboard'u ile aynı hesap kullanıldığından iki ekran arasında gün farkı olmaz.
let cachedRemainingDays;

const Header = () => {
  const dispatch = useDispatch();
  const authUser = useSelector((store) => store.auth.authUser);
  const loginSettings = useSelector((store) => store.auth.loginSettings);
  
  // Rol erişim hook'u
  const { userRole, filterMenusByRole } = useRoleAccess();
  const profilePhoto = useSelector((store) => store.profile.profilePhoto);
  const profileDetail = useSelector((store) => store.profile.profileDetail);
  const cartData = useSelector((store) => store.cart.cartData);
  const searchData = useSelector((store) => store.search.searchData);
  const brandCartList = useSelector((store) => store.shop.brandCartList);
  const brandSalesMode = useSelector((store) => store.brand.brandSalesMode);
  const activeComponents = useSelector((store) => store.auth.activeComponents);

  // BRAND_PRODUCTS_SALES_MODE: false ise marka sepeti (/brand-cart) ikonu gizlenir.
  const isBrandSalesEnabled = brandSalesMode !== false;
  const notifications = useSelector((store) => store.profile.notification);
  const [profilePhotoItem, setProfilePhotoItem] = useState(null);
  const [responseItem, setResponseItem] = useState(0);
  const [responseBrandItem, setResponseBrandItem] = useState(0);
  const [search, setSearch] = useState("");
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const [isMenuLoading, setIsMenuLoading] = useState(true);
  const [hiddenProfileMenus, setHiddenProfileMenus] = useState([]);

  const [score, setScore] = useState(profileDetail?.score || 0); // Local state to track score

  // Program bitiş tarihi (İşletme / Usta için "kalan gün" rozetinde gösterilir).
  const [programEnd, setProgramEnd] = useState(
    cachedProgramEnd !== undefined ? cachedProgramEnd : null
  );

  // Program bitişine kalan tam gün sayısı — admin dashboard'u ile tutarlı olması
  // için backend'in strip endpoint'inde hesapladığı değer doğrudan kullanılır.
  const [daysLeft, setDaysLeft] = useState(
    cachedRemainingDays !== undefined ? cachedRemainingDays : null
  );

  // Active Component Check
  const isComponentActive = (componentName, componentList) => {
    // If componentName is not specified, always consider it active
    if (!componentName) return true;

    // componentList check
    if (!componentList || !componentList.length) return false;

    // Active component find
    return componentList.some(
      (item) => item.active && item.componentName === componentName
    );
  };

  const [menuItems, setMenuItems] = useState([
    { id: 1, title: "Ürünlerimiz", url: "/brands", componentName: "MARKALAR" },
    // Kampanyalarımız: rol bazlı görünürlük menü deny-list (getTenantMenu)
    // mekanizmasıyla yönetilir; componentName YOK ki activeComponents gerektirmesin.
    { id: 5, title: "Kampanyalarımız", url: "/campaigns" },
    {
      id: 2,
      title: "Oyunlar",
      url: "/games",
      subMenu: [
        {
          id: 200,
          title: "Eşini Bul",
          url: "/games/find-mate",
          componentName: "EŞLE KAZAN",
        },
        {
          id: 201,
          title: "Kelime Bulmaca",
          url: "/games/word-puzzles",
          componentName: "KELİME AVI",
        },
        {
          id: 202,
          title: "Puan Avı",
          url: "/games/score-hunt",
          componentName: "PUAN AVI",
        },
        {
          id: 203,
          title: "Resmi Tahmin Et",
          url: "/games/guess-picture",
          componentName: "RESMİ TAHMİN ET",
        },
        {
          id: 204,
          title: "Şans Çarkı",
          url: "/games/question-wheel",
          componentName: "ŞANS ÇARKI",
        },
        {
          id: 205,
          title: "Kim 1000 Puan İster",
          url: "/games/who-wants-score",
          componentName: "KİM 1000 PUAN İSTER",
        },
        {
          id: 206,
          title: "En İyi Tabağını Yükle",
          url: "/games/best-plate",
          componentName: "EN İYİ TABAK",
        },
      ],
    },
    { id: 3, title: "Dükkan", url: "/shop", componentName: "ÜRÜNLER" },
    {
      id: 4,
      title: "Bizim Dünya",
      subMenu: [
        {
          id: 100,
          title: "Akademi",
          url: "/academy",
          componentName: "AKADEMİ",
        },
        { id: 101, title: "Blog", url: "/magazine", componentName: "DERGİ" },
        {
          id: 102,
          title: "Forum",
          url: "/forum",
          componentName: "BİZİM MEYDAN",
        },
        {
          id: 103,
          title: "Liderler Tablosu",
          url: "/leaderboard",
          componentName: "LİDERLER TABLOSU",
        },
        { id: 104, title: "İçeriklerimiz", url: "/tv", componentName: "TV" },
      ],
    },
  ]);

  const infoModalMenuItems = useMemo(
    () => [
      { id: 1, title: "Hesap Bilgilerim", url: "/profile/account-info" },
      { id: 2, title: "Giriş Detaylarım", url: "/profile/login-details" },
      { id: 3, title: "Adres Bilgilerim", url: "/profile/address" },
      { id: 4, title: "Mesajlarım", url: "/profile/messages" },
      { id: 5, title: "Fotoğraflarım", url: "/profile/photos" },
      { id: 6, title: "Fiş Okut", url: "/profile/receipt-scan" },
      { id: 7, title: "Puan Geçmişim", url: "/profile/scores" },
      ...(isCharityScoreEnabled
        ? [{ id: 8, title: "İyilik Puan Geçmişim", url: "/profile/charity-scores" }]
        : []),
      { id: 9, title: "Ödül Siparişlerim", url: "/profile/orders" },
      ...(isBrandSalesEnabled
        ? [{ id: 10, title: "Ürün Siparişlerim", url: "/profile/brand-orders" }]
        : []),
      { id: 11, title: "Favorilerim", url: "/profile/favourites" },
      { id: 12, title: "Performans", url: "/profile/performance" },
      { id: 13, title: "Dashboard", url: "/profile/dashboard" },
      { id: 14, title: "Kod Girişi", url: "/profile/code-entry" },
      { id: 15, title: "Fikir Gönder", url: "/profile/send-idea" },
      ...(isComponentActive("ROZET", activeComponents)
        ? [{ id: 16, title: "Rozetlerim", url: "/profile/badges" }]
        : []),
      { id: 17, title: "Arkadaşını Getir", url: "/profile/my-references" },
      { id: 18, title: "Bağlı Ustalar", url: "/profile/connected-chefs" },
      { id: 19, title: "İşletmeni Getir", url: "/profile/my-business-references" },
    ],
    [isBrandSalesEnabled, activeComponents]
  );

  useEffect(() => {
    // profileDetail değiştiğinde score'u güncelle
    if (profileDetail?.score) {
      setScore(profileDetail.score);
    }
  }, [profileDetail]);

  const handleProfileDropdown = (e) => {
    e.preventDefault();
    setShowProfileDropdown(!showProfileDropdown);
    dispatch(profileAction.getProfileAllPointHistory());
  };

  //Secure Logout
  const logout = (e) => {
    e.preventDefault();
    
    dispatch(
      authAction.logout(
        localStorage.getItem("token"),
        localStorage.getItem("refreshToken")
      )
    )
      .then((res) => {
        if (res.isHttpSuccess) {
          setTimeout(function () {
            clearStorageRetainCookies();
            window.location.reload();
          }, 500);
        }
      })
      .catch((err) => {
        if (err.isHttpError) {
          setTimeout(function () {
            clearStorageRetainCookies();
            window.location.replace("/login");
          }, 500);
        }
      });
  };

  useEffect(() => {
    dispatch(profileAction.getProfilePhoto());
    dispatch(profileAction.getLoginUserDetail());
    dispatch(shopAction.getCart());
    dispatch(shopAction.getBrandCartList());
    dispatch(profileAction.getNotifications());
    dispatch(profileAction.getProfileAllPointHistory());
    dispatch(brandAction.getBrandProductsSalesMode());
    return () => {};
  }, [dispatch]);

  // Bayi / İşletme / Usta / bayi sorumlusu segmentindeki kullanıcı için program bitiş
  // tarihini çek (segment kontrolü rol KODU üzerinden — bkz. @utils/roleSegment).
  useEffect(() => {
    if (!isProgramCounterSegment(authUser, userRole)) {
      return;
    }
    if (cachedProgramEnd !== undefined) {
      setProgramEnd(cachedProgramEnd);
      setDaysLeft(cachedRemainingDays);
      return;
    }
    API.get("/management/budget/me/strip")
      .then((res) => {
        if (res?.isHttpSuccess) {
          cachedProgramEnd = res.data?.programDateEnd || null;
          cachedRemainingDays = res.data?.remainingDays ?? null;
          setProgramEnd(cachedProgramEnd);
          setDaysLeft(cachedRemainingDays);
        }
      })
      .catch(() => {});
  }, [authUser, userRole]);

  useEffect(() => {
    if (authUser) {
      setIsMenuLoading(true);
      dispatch(profileAction.getTenantMenu(authUser?.roleId))
        .then((res) => {
          // res.data var mı diye kontrol ediyoruz
          if (res.isHttpSuccess && Array.isArray(res.data)) {
            // res.data içinde item ve item.menu var mı diye kontrol ediyoruz
            const tenantPaths = res.data.map(
              (item) => item?.menu?.pathUrl || ""
            );
            
            setHiddenProfileMenus(tenantPaths);

            const filteredMenu = menuItems
              .map((menuItem) => {
                const newItem = { ...menuItem };
                if (newItem.subMenu && Array.isArray(newItem.subMenu)) {
                  newItem.subMenu = newItem.subMenu.filter(
                    (subItem) => !tenantPaths.includes(subItem.url)
                  );
                }
                return tenantPaths.includes(newItem.url) ? null : newItem;
              })
              .filter((item) => item !== null);

            setMenuItems(filteredMenu);
          }
        })
        .catch((error) => {
          console.log("Tenant menüsü yüklenirken hata oluştu:", error);
        })
        .finally(() => {
          setIsMenuLoading(false);
        });
    }

    return () => {};
  }, [authUser]);

  useEffect(() => {
    if (
      cartData &&
      cartData.cartProductDTOList &&
      cartData.cartProductDTOList.length > 0
    ) {
      var res = 0;
      for (const item of cartData?.cartProductDTOList) {
        res += item?.productCount;
      }
      setResponseItem(res);
    } else {
      setResponseItem(0);
    }

    return () => {};
  }, [cartData]);

  useEffect(() => {
    if (
      brandCartList &&
      brandCartList?.brandStyleCartProductDTOList &&
      brandCartList?.brandStyleCartProductDTOList?.length > 0
    ) {
      var res = 0;
      for (const item of brandCartList?.brandStyleCartProductDTOList) {
        res += item?.brandStyleCount;
      }
      setResponseBrandItem(res);
    } else {
      setResponseBrandItem(0);
    }
  }, [brandCartList]);

  useEffect(() => {
    if (profilePhoto) {
      for (let i = 0; i < profilePhoto.length; i++) {
        if (
          profilePhoto[i].imageStatus === "APPROVED" &&
          profilePhoto[i].employeeImageContentType === "PROFILE"
        ) {
          setProfilePhotoItem(profilePhoto[i]);
        }
      }
    }

    return () => {};
  }, [profilePhoto]);

  useEffect(() => {
    $('[data-toggle="offcanvas"]').on("click", function () {
      $(".offcanvas-collapse").toggleClass("open");
      $(".offcanvas-overlay").toggleClass("open");
      $(".page-content").toggleClass("blur");
      $(".user-avatar").toggleClass("blur");
    });

    $(".offcanvas-overlay").on("click", function () {
      $(".offcanvas-collapse").toggleClass("open");
      $(".offcanvas-overlay").toggleClass("open");
      $(".page-content").toggleClass("blur");
      $(".user-avatar").toggleClass("blur");
    });

    return () => {};
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (search.length > 2) {
        dispatch(searchAction.getSearch(search));
        setIsSearchOpen(true);
      } else {
        setIsSearchOpen(false);
      }
    }, 600); // 600ms gecikme süresi

    return () => clearTimeout(delayDebounceFn);
  }, [search, dispatch]);

  const formatDateString = (dateString) => {
    const [datePart, timePart] = dateString.split(" ");
    const [day, month, year] = datePart.split("-");
    return `${day}.${month}.${year}`;
  };

  // Filtrelenmiş menü öğelerini oluştur
  const filteredMenuItems = useMemo(() => {
    return menuItems
      .map((menuItem) => {
        // Ana menü öğesi kontrolü
        if (!isComponentActive(menuItem.componentName, activeComponents)) {
          return null;
        }

        // Alt menü öğeleri kontrolü (varsa)
        if (menuItem.subMenu && Array.isArray(menuItem.subMenu)) {
          const filteredSubMenu = menuItem.subMenu.filter((subItem) =>
            isComponentActive(subItem.componentName, activeComponents)
          );

          // Eğer alt menü öğeleri kalmadıysa, ana menüyü de gösterme
          if (filteredSubMenu.length === 0) {
            return null;
          }

          return {
            ...menuItem,
            subMenu: filteredSubMenu,
          };
        }

        return menuItem;
      })
      .filter((item) => item !== null);
  }, [menuItems, activeComponents]);

  // useEffect hook'unu ekleyin:
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        showNotificationModal &&
        !e.target.closest(".notification-dropdown") &&
        !e.target.closest(".notification-bell")
      ) {
        setShowNotificationModal(false);
      }

      if (
        showSearchDropdown &&
        !e.target.closest(".search-dropdown") &&
        !e.target.closest(".search-icon")
      ) {
        setShowSearchDropdown(false);
      }

      if (
        showProfileDropdown &&
        !e.target.closest(".profile-dropdown") &&
        !e.target.closest(".profile-trigger")
      ) {
        setShowProfileDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showNotificationModal, showSearchDropdown, showProfileDropdown]);

  // Bildirim indikatörü için ekleyin:
  const NotificationBell = ({ count }) => (
    <div className="position-relative">
      <FaBell className="text-gray-special" />
      {count > 0 && <span className="shopping-cart-count">{count}</span>}
    </div>
  );

  const handleClickHamburger = () => {
    console.log("handleClickHamburger");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="sticky-top bg-white shadow-lg">
      <header>
        {/* <div className="alert alert-dismissible border-0 bg-blue-lighter text-blue-light small text-center mb-0 fade show">
          <i className="fas fa-info-circle me-2" />
          Yeni yarışma yayınlandı. Detayları incelemek için{" "}
          <a href="#" className="text-reset">
            tıklayın
          </a>
          .
          <button type="button" className="btn-close" data-bs-dismiss="alert" />
        </div> */}

        <nav className="navbar navbar-expand-xl">
          <div className="container-xxl">
            <a href="/home" className="navbar-logo">
              <img
                src={getLogoUrl(loginSettings?.logo)}
                alt="logo-header"
                onError={(e) => handleLogoError(e)}
              />

              {/* Kullanıcı Rol Gösterimi */}
              {userRole && (
                <div className="role-badge">
                  <span className="role-text">{userRole}</span>
                </div>
              )}
            </a>

            <div className="header-actions order-xl-2 order-1 col-xl-2 ms-auto">
              <div className="flex justify-content-end align-items-center mb-2">
                <div className="position-relative">
                  <div
                    className="notification-bell profile-icon position-relative mx-2 px-1"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      setShowNotificationModal(!showNotificationModal)
                    }
                  >
                    <NotificationBell
                      count={
                        Array.isArray(notifications)
                          ? notifications.filter((notif) => notif?.unread)
                              .length
                          : 0
                      }
                    />
                  </div>

                  <div
                    className={`notification-dropdown ${
                      showNotificationModal ? "show" : ""
                    }`}
                  >
                    <div className="notification-header">
                      <div className="fw-bold" style={{ fontSize: "14px" }}>
                        Bildirimler
                      </div>
                      <button
                        className="mark-all-button"
                        onClick={() =>
                          dispatch(profileAction.markNotificationAsRead()).then(
                            () => {
                              dispatch(profileAction.getNotifications());
                            }
                          )
                        }
                      >
                        Tümünü okundu işaretle
                      </button>
                    </div>

                    <div className="notification-body">
                      {Array.isArray(notifications) &&
                      notifications.length > 0 ? (
                        notifications.map((notification) => (
                          <div
                            key={notification.id}
                            className={`notification-item ${
                              notification.unread ? "unread" : ""
                            }`}
                          >
                            <div
                              className={`notification-icon ${
                                notification.unread ? "unread" : "read"
                              }`}
                            >
                              <FaBell size={16} />
                            </div>
                            <div className="notification-content">
                              <div
                                className={`notification-title ${
                                  notification.unread ? "unread" : "read"
                                }`}
                              >
                                {notification.subject}
                                {notification.unread && (
                                  <span className="notification-badge">
                                    Yeni
                                  </span>
                                )}
                              </div>
                              <p className="notification-message">
                                {notification.body}
                              </p>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="notification-empty">
                          Henüz bildiriminiz bulunmamaktadır.
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Search */}
                <div className="wrapperSearchIcon">
                  <div
                    className="search-icon profile-icon position-relative mx-2 px-1"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowSearchDropdown(!showSearchDropdown)}
                    title="Arama"
                  >
                    <FaSearch className="text-gray-special" />
                  </div>

                  <div
                    className={`search-dropdown ${
                      showSearchDropdown ? "show" : ""
                    }`}
                  >
                    <div className="search-header">
                      <div className="fw-bold" style={{ fontSize: "14px" }}>
                        Arama
                      </div>
                      <div
                        className="close-icon"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowSearchDropdown(false)}
                      >
                        <FaTimes size={16} />
                      </div>
                    </div>
                    <div className="search-body">
                      <div className="search-item">
                        <input
                          className="search-input"
                          placeholder="Aradığınız kelimeyi yazın..."
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                          autoFocus
                        />
                      </div>

                      {search.length > 2 && searchData?.length > 0 ? (
                        searchData.map((item) => (
                          <a
                            key={item.id}
                            href={item.resultPageURL}
                            className="search-item text-decoration-none text-dark"
                          >
                            <div>
                              <div className="fw-bold">{item.name}</div>
                              <div className="text-muted small">
                                {item.tableName}
                              </div>
                            </div>
                          </a>
                        ))
                      ) : search.length > 2 && searchData?.length === 0 ? (
                        <div className="search-empty">
                          Aradığınız sonuç bulunamadı.
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>

                {/* Mağaza Sepeti */}
                {!hiddenProfileMenus.includes("/shop") && (
                  <Link
                    to="/cart"
                    className="profile-icon position-relative mx-2 px-1"
                    title="Mağaza Sepeti"
                  >
                    <FaGift className="text-gray-special" />
                    {responseItem && responseItem > 0 ? (
                      <span className="shopping-cart-count">{responseItem}</span>
                    ) : null}
                  </Link>
                )}

                {/* Marka Sepeti */}
                {isBrandSalesEnabled && (
                  <Link
                    to="/brand-cart"
                    className="profile-icon position-relative mx-2 px-1"
                    title="Marka Sepeti"
                  >
                    <FaShoppingCart className="text-gray-special" />
                    {responseBrandItem && responseBrandItem > 0 ? (
                      <span className="shopping-cart-count">
                        {responseBrandItem}
                      </span>
                    ) : null}
                  </Link>
                )}
              </div>

              <a
                className="d-flex justify-content-end align-items-center text-decoration-none profile-trigger position-relative"
                style={{ cursor: "pointer" }}
                onClick={(e) => handleProfileDropdown(e)}
              >
                {/* Program bitişine kalan gün (İşletme / Usta) */}
                {programEnd && daysLeft !== null && daysLeft >= 0 && (
                  <div
                    className="program-end-cal me-3"
                    title="Program Bitişine Kalan Süre"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="pec-top">KALAN</div>
                    <div className="pec-day">{daysLeft}</div>
                    <div className="pec-year">GÜN</div>
                  </div>
                )}

                {localStorage.getItem("tenantName") === "tenant3" && (
                  <img
                    src={Badge}
                    alt="badge"
                    className="me-2"
                    style={{ width: 48 }}
                  />
                )}

                {profilePhotoItem?.imageUrl ? (
                  <img
                    src={profilePhotoItem?.imageUrl}
                    alt="user-profile"
                    className="shadow-sm rounded-circle"
                    style={{ height: 48 }}
                  />
                ) : (
                  <div
                    className="shadow-sm rounded-circle bg-gray d-flex flex-col justify-content-center align-items-center"
                    style={{ height: 48, width: 48 }}
                  >
                    <FaUser
                      className="text-gray-special"
                      style={{ width: 24, height: 24, color: "#fff" }}
                    />
                  </div>
                )}
                <div className="ms-3">
                  <h6 className="mb-0">
                    {profileDetail?.employeeDTO?.name}{" "}
                    {profileDetail?.employeeDTO?.surname}
                  </h6>
                  {!hiddenProfileMenus.includes("/profile/scores") && (
                    <span className="text-green small fw-bold">
                      {score} Puan
                    </span>
                  )}
                </div>

                {/* Profile Dropdown */}
                <div className={`profile-dropdown ${showProfileDropdown ? "show" : ""}`}>
                  <div className="profile-header">
                    <div className="points-section">
                      {!hiddenProfileMenus.includes("/profile/scores") && (
                      <div className="point-item">
                        <FaCoins className="text-primary" />
                        <span>{profileDetail?.score || 0} Puan</span>
                      </div>
                      )}
                      {isCharityScoreEnabled && (
                      <div className="point-item">
                        <FaHeart className="text-danger" />
                        <span>{profileDetail?.charityScore || 0} İyilik Puanı</span>
                      </div>
                      )}
                    </div>
                  </div>
                  <div className="profile-body">
                    <div className="menu-section">
                      {!hiddenProfileMenus.includes('/profile/orders') && (
                      <Link to="/profile/orders">
                        <FaShoppingBag className="menu-icon" />
                        Siparişlerim
                      </Link>
                      )}
                      {!hiddenProfileMenus.includes('/profile/scores') && (
                      <Link to="/profile/scores">
                        <FaStar className="menu-icon" />
                        Puanlarım
                      </Link>
                      )}
                      {!hiddenProfileMenus.includes('/profile/receipt-scan') && (
                      <Link to="/profile/receipt-scan">
                        <FaReceipt className="menu-icon" />
                        Oyunlarım
                      </Link>
                      )}
                      {!hiddenProfileMenus.includes('/profile/messages') && (
                      <Link to="/profile/messages">
                        <FaEnvelope className="menu-icon" />
                        Mesajlarım
                      </Link>
                      )}
                      {!hiddenProfileMenus.includes('/profile/favourites') && (
                      <Link to="/profile/favourites">
                        <FaHeart className="menu-icon" />
                        Favorilerim
                      </Link>
                      )}
                      {!hiddenProfileMenus.includes('/profile/performance') && (
                      <Link to="/profile/performance">
                        <FaChartBar className="menu-icon" />
                        Performans Bilgilerim
                      </Link>
                      )}
                      {isComponentActive("ROZET", activeComponents) && !hiddenProfileMenus.includes('/profile/badges') && (
                      <Link to="/profile/badges">
                        <FaMedal className="menu-icon" />
                        Rozetlerim
                      </Link>
                      )}
                      {!hiddenProfileMenus.includes('/profile/my-references') && (
                      <Link to="/profile/my-references">
                        <FaUsers className="menu-icon" />
                        Arkadaşını Getir
                      </Link>
                      )}
                      {!hiddenProfileMenus.includes('/profile/connected-chefs') && (
                      <Link to="/profile/connected-chefs">
                        <FaUsers className="menu-icon" />
                        Bağlı Ustalar
                      </Link>
                      )}
                      {!hiddenProfileMenus.includes('/profile/my-business-references') && (
                      <Link to="/profile/my-business-references">
                        <FaStore className="menu-icon" />
                        İşletmeni Getir
                      </Link>
                      )}
                      {!hiddenProfileMenus.includes('/profile/account-info') && (
                      <Link to="/profile/account-info">
                        <FaUserCog className="menu-icon" />
                        Hesap Bilgilerim
                      </Link>
                      )}
                      <div className="divider"></div>
                      <a href="#" onClick={(e) => logout(e)}>
                        <FaSignOutAlt className="menu-icon" />
                        Çıkış Yap
                      </a>
                    </div>
                  </div>
                </div>
              </a>
            </div>

            <button
              className="navbar-toggler collapsed order-xl-3 order-2"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target=".navbar-collapse"
              onClick={() => handleClickHamburger()}
            >
              <span />
              <span />
              <span />
            </button>

            <div className="collapse navbar-collapse order-xl-1 order-3 col-xl-auto">
              {!isMenuLoading && <NavigationMenu menuItems={filteredMenuItems} />}
            </div>
          </div>
        </nav>
      </header>

      {showModal && (
        <Modal onClose={() => setShowModal(false)} isOpen={showModal}>
          <div className="userInfoModalContent">
            <div className="infoModalMenuItems">
              {infoModalMenuItems.filter(item => {
                if (['/profile/orders', '/profile/brand-orders'].includes(item.url)) return !hiddenProfileMenus.includes('/profile/orders');
                if (['/profile/scores', '/profile/charity-scores'].includes(item.url)) return !hiddenProfileMenus.includes('/profile/scores');
                if (['/profile/receipt-scan', '/profile/code-entry', '/profile/send-idea'].includes(item.url)) return !hiddenProfileMenus.includes('/profile/receipt-scan');
                if (['/profile/messages'].includes(item.url)) return !hiddenProfileMenus.includes('/profile/messages');
                if (['/profile/favourites'].includes(item.url)) return !hiddenProfileMenus.includes('/profile/favourites');
                if (['/profile/performance', '/profile/dashboard'].includes(item.url)) return !hiddenProfileMenus.includes('/profile/performance');
                if (['/profile/badges'].includes(item.url)) return !hiddenProfileMenus.includes('/profile/badges');
                if (['/profile/my-references'].includes(item.url)) return !hiddenProfileMenus.includes('/profile/my-references');
                if (['/profile/connected-chefs'].includes(item.url)) return !hiddenProfileMenus.includes('/profile/connected-chefs');
                if (['/profile/my-business-references'].includes(item.url)) return !hiddenProfileMenus.includes('/profile/my-business-references');
                if (['/profile/account-info', '/profile/login-details', '/profile/address', '/profile/photos'].includes(item.url)) return !hiddenProfileMenus.includes('/profile/account-info');
                return true;
              }).map((item) => (
                <a key={item?.id} href={item?.url}>
                  {item?.title}
                </a>
              ))}
              <span onClick={() => logout()}>Çıkış</span>
            </div>
            <div className="infoModalScoreSection">
              <div className="d-flex flex-column gap-3 py-2">
                <span className="badge rounded-pill text-white bg-blue px-4 py-2 fs-3">
                  <FaCoins className="text-white" /> {profileDetail?.score || 0}{" "}
                  Puan
                </span>
                {isCharityScoreEnabled && (
                <span className="badge rounded-pill text-white bg-blue px-5 py-2 fs-3">
                  <FaHeart className="text-white" />{" "}
                  {profileDetail?.charityScore || 0} İyilik Puanı
                </span>
                )}
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default Header;
